module.exports = __webpack_public_path__ + "static/black-logo-7a624b320c80ce4b3cfdc200b62fcef3.svg";